/**
 * Composant générique de squelette de route. Chaque page listée dans
 * apps/web/app/(shop|account|admin)/**\/page.tsx a un équivalent ici qui rend
 * ce composant — le contenu réel de chaque page est hors périmètre de ce lot
 * de scaffolding (cf. rapport de la tâche), laissé aux ateliers suivants
 * (storefront, panier/commande, compte, admin, contenu statique).
 */
export function RouteStub({ name, path }: { name: string; path: string }) {
  return (
    <div className="container-vvs py-12">
      <p className="font-body text-xs uppercase tracking-wide text-muted">Route : {path}</p>
      <h1 className="mt-2 font-display text-2xl font-semibold text-navy">TODO : {name}</h1>
      <p className="mt-2 font-body text-sm text-muted">
        Page à construire par l&apos;atelier correspondant — squelette posé par le scaffolding apps/web-vite.
      </p>
    </div>
  );
}
